import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { AuthProvider } from 'contexts/auth';

import {Router} from './routes';

import GlobalStyle from './styles/global';
import { NotificationProvider } from 'contexts/notification';

const baseName = process.env.PUBLIC_URL || undefined;

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <NotificationProvider>
        <BrowserRouter basename={baseName}>
          <Router />
        </BrowserRouter>
      </NotificationProvider>
    </AuthProvider>
    <GlobalStyle />
    <ToastContainer autoClose={5000} />
  </React.StrictMode>,
  document.getElementById('root'),
);
